import Resource from '@/api/resources/Resource'

class UserappOperationConfigurationServices extends Resource {
    async getUserappOperationsByUserappId(userappId) {
        const response = await this.axios.get(`/configuration/userapps/${userappId}/userappOperations`)
        return response.data
    }
    async createUserappOperation(userappOperationCreateRequest) {
        const response = await this.axios.post(`/configuration/userappOperations`, userappOperationCreateRequest)
        return response.data
    }
    async deleteUserappOperation(userappOperationId) {
        const response = await this.axios.delete(`/configuration/userappOperations/${userappOperationId}`)
        return response.data
    }
}

export default new UserappOperationConfigurationServices()
